import React from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature, useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {ApplicationStoreType} from 'desktop/store';
import {OrderReviewTotalsSegmentsType} from 'desktop/types/orderReviewTotalsType';

import {
    getGrandTotal,
    getSubtotal,
    getTotalRebateSum,
    getCartTotalWithRebate,
} from '../../store/selectors/orderReviewTotals/orderReviewTotals';

import {RebateGrandTotal} from '../rebateGrandTotal/rebateGrandTotal';

import s from './cartGrandTotal.scss';

export type PropsType = {
    grandTotal: OrderReviewTotalsSegmentsType;
    subtotal: OrderReviewTotalsSegmentsType;
    isScrollOnBottom: boolean;
    totalRebateDiscount: number;
    totalWithRebate: number;
};

/**
 * Cart Footer for checkout page
 *
 * @constructor
 */
export const CartGrandTotal: React.FC<PropsType> = ({
    grandTotal,
    isScrollOnBottom,
    subtotal,
    totalRebateDiscount,
    totalWithRebate,
}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const isShowSubtotal =
        Boolean(subtotal.noSpecialPriceWithTax) &&
        subtotal.noSpecialPriceWithTax !== grandTotal.price;

    const isClRebate = useFeature('clRebate');
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    return (
        <>
            {totalRebateDiscount && isClRebate ? (
                <div
                    className={classNames(s.row, s.grandTotal, s.isClRebate, {
                        [s.onBottom]: isScrollOnBottom,
                        [s.rowFacelift]: isFacelift,
                    })}
                >
                    <RebateGrandTotal
                        eventName="checkoutReview"
                        price={grandTotal.price}
                        size="large"
                        title={grandTotal.title}
                        totalRebateDiscount={totalRebateDiscount}
                        totalWithRebate={totalWithRebate}
                    />
                </div>
            ) : (
                <div
                    className={classNames(s.row, s.grandTotal, {
                        [s.onBottom]: isScrollOnBottom,
                        [s.rowFacelift]: isFacelift,
                    })}
                >
                    <>
                        <span className={s.label}>{grandTotal.title}:</span>
                        <span>
                            {isShowSubtotal && (
                                <span className={s.price}>
                                    <Price>{subtotal.noSpecialPriceWithTax}</Price>
                                </span>
                            )}
                            <span
                                className={classNames(s.totalPrice, {
                                    [s.totalUnderDiscountFlag]: isDiscountColor,
                                })}
                                aria-label="total price"
                            >
                                <span className={classNames({[s.discounted]: isShowSubtotal})}>
                                    <Price>{grandTotal.price}</Price>
                                </span>
                            </span>
                        </span>
                    </>
                </div>
            )}
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    grandTotal: getGrandTotal(store),
    subtotal: getSubtotal(store),
    totalRebateDiscount: getTotalRebateSum(store),
    totalWithRebate: getCartTotalWithRebate(store),
});

export const CartGrandTotalConnected = connect(mapStateToProps)(CartGrandTotal);
